export default __webpack_public_path__ + "static/image04-099dfa3fa6b6f45c944079764634b31d.webp";